import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-bold",
  {
    variants: {
      variant: {
        default: "bg-bg-main text-text-secondary",
        live: "bg-green-100 text-accent-green",
        blue: "bg-blue-100 text-accent-blue",
        red: "bg-accent-red text-white",
        amber: "bg-orange-100 text-accent-orange",
      },
    },
    defaultVariants: { variant: "default" },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
